import React, { useState, useEffect, useCallback } from "react";
import { Container, Box } from "@material-ui/core";
import {
    Typography,
    AppBar,
    Toolbar,
    Link,
    CardActionArea,
    TextField,
    Button,
    Chip,
    Paper,
    FormControlLabel,
    IconButton,
    Avatar,
    Tooltip,
} from "@material-ui/core";
import {
    CircularProgress,
    Grid,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    DialogContentText,
    LinearProgress,
    InputLabel,
    Select,
    FormHelperText,
    MenuItem,
    FormControl,
    Switch,
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    ListItemSecondaryAction, Input
} from "@material-ui/core";
import {
    DesktopMac,
    Add,
    FilterList,
    CheckCircle,
    Block,
    Delete,
    Edit,
    AccountCircle,
    Close,
    PermIdentity,
    ArrowForwardIos,
    SubdirectoryArrowLeftOutlined,
    AccountBalance,
    Schedule,
    Money,
    VpnLock,
    AccountBalanceWallet
} from "@material-ui/icons";
import { withLocalize, Translate } from "react-localize-redux";
import { useHistory } from "react-router-dom";
import { useRoles, useOrgRoles } from "../../../../hooks/use_hooks";

import MUIDataTable from "mui-datatables";
import MaskedInput from "react-text-mask";

import { makeStyles } from "@material-ui/styles";
import {
    FinanceService,
    AdminService,
    ReportingService,
    Validator,
    Permissions,
} from "../../../../../../utils/web_config";
import { useSnackbar } from "notistack";
import { MuiPickersUtilsProvider, DatePicker, TimePicker, KeyboardTimePicker, DateTimePicker } from "@material-ui/pickers";
import Format from "date-fns/format";
import DateFnsUtils from "@date-io/date-fns";

const axios = require("axios");

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        [theme.breakpoints.up("sm")]: {
            marginLeft: 250,
        },
    },
    title: {
        flexGrow: 1,
    },
    btn: {
        textTransform: "capitalize",
    },
    btn2: {
        textTransform: "capitalize",
        border: "dashed grey 1px",
    },
    paper: {
        padding: 15,
    },
    action: {
        borderRadius: 15,
    },
}));




function BnrTrustAccReport(props) {
    const classes = useStyles();
    const history = useHistory();

    const ad = localStorage.getItem("nx_cent");
    const roles = useOrgRoles({
        org_id: JSON.parse(ad)?.organization.organization_id,
    });

    const [accountData, setAccountData] = useState({});

    const [addNewOpen, setAddNewOpen] = useState(false);

    const [agents, setAgents] = useState({
        page: 0,
        count: 1,
        rowsPerPage: 10,
        sortOrder: {},
        saving: false,
        loading: false,
        toggling: false,
        data: [],
    });

    const [selectedAgent, setSelectedAgent] = useState({
        saving: false,
        loading: false,
        data: {},
    });

    const [agentAccount, setAgentAccount] = useState({
        saving: false,
        loading: false,
        data: {},
    });

    const [agentEditMode, setAgentEditMode] = useState({
        status: false,
        suspend: false,
    });



    const [status, setStatus] = useState("Loading BNR Report....");
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();



    const [business_date, setBusinessDate] = useState({ value: Format(new Date(), ["dd-MMM-yyyy"]), error:""});
    const [bank_le_book,setBankLeBook]=useState({ value: "", error:"" });
    const [trust_acct_open_bal_lcy, settrust_acct_open_bal_lcy] = useState({ value: 0, error: ""});
    const [trust_acct_dep_bal_lcy, settrust_acct_dep_bal_lcy]=useState({value: 0, error: ""});
    const [trust_acct_wd_bal_lcy, settrust_acct_wd_bal_lcy]=useState({value:0,error:""});
    const [trust_acct_close_bal_lcy, settrust_acct_close_bal_lcy]=useState({ value:0,error:""});
    const [eplat_acct_open_bal_lcy, seteplat_acct_open_bal_lcy]=useState({value:0,error:""});
    const [eplat_acct_dep_bal_lcy, seteplat_acct_dep_bal_lcy]=useState({ value:0,error:""});
    const [eplat_acct_wd_bal_lcy, seteplat_acct_wd_bal_lcy]=useState({ value:0,error:""});
    const [eplat_acct_close_bal_lcy, seteplat_acct_close_bal_lcy]=useState({ value:0, error:""});
    const [reason_for_difference, setreason_for_difference]=useState({ value:"",error:""});

    const [idData, setIdData] = useState({
        loading: false,
        saving: false,
        open: false,
    });


    useEffect(() => {
        var accountData = new AdminService().accountData;
        setAccountData(accountData);
        getBnrTrustAccReport(accountData.token);
    }, []);



    ////////

    const onRegisterClick = () => {
        if (bank_le_book.value === "") {
            setBankLeBook({
                value: "",
                error: "Please provide bank le book",
            });
        } else if (business_date.value === ""){
            setBusinessDate({
                value: "",
                error: "Please pick business date",
            });
        }
        else {
            recordReport();
        }
    };

    /////////////

    const clearUserInfo = () => {
        setBusinessDate({ value: "", error: "" });
        setBankLeBook({ value: "", error: "" });
        settrust_acct_open_bal_lcy({ value: 0, error: "" });
        settrust_acct_dep_bal_lcy({ value: 0, error: "" });
        settrust_acct_wd_bal_lcy({ value: 0, error: "" });
        settrust_acct_close_bal_lcy({ value: 0, error: "" });
        seteplat_acct_open_bal_lcy({ value: 0, error: "" });
        seteplat_acct_dep_bal_lcy({ value: 0, error: "" });
        seteplat_acct_wd_bal_lcy({ value: 0, error: "" });
        seteplat_acct_close_bal_lcy({ value: 0, error: "" });
        setreason_for_difference({ value: "", error: "" });
    };



    const columns = [
        {
            name: "business_date",
            label: "Business Date",
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: "bank_le_book",
            label: "Bank le book",
            options: {
                filter: false,
                sort: true,
            },
        },
        {
            name: "trust_acct_open_bal_lcy",
            label: "Trust Acc Opening Balance in LCY",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "trust_acct_dep_bal_lcy",
            label: "Trust Acc Deposit Balance in LCY",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "trust_acct_wd_bal_lcy",
            label: "Trust Acc Withdrawal Balance in LCY",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "trust_acct_close_bal_lcy",
            label: "Trust Acc Closing Balance in LCY",
            options: {
                filter: true,
                sort: true,
            },
        },
        {
            name: "eplat_acct_open_bal_lcy",
            label: "E-Platform Opening Balance in LCY",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "eplat_acct_dep_bal_lcy",
            label: "E-Platform Deposit Balance in LCY",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "eplat_acct_wd_bal_lcy",
            label: "E-Platform Withdrawal Balance in LCY",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "eplat_acct_close_bal_lcy",
            label: "E-Platform Closing Balance in LCY",
            options: {
                filter: false,
                sort: false,
            },
        },
        {
            name: "reason_for_difference",
            label: "Reason in case of difference",
            options: {
                filter: false,
                sort: false,
            },
        }
    ];


    const options = {
        filterType: "multiselect",
        elevation: 0,
        selectableRows: false,
        searchPlaceholder: "Search agent...",
        selectableRowsOnClick: false,
        fixedHeader: true,
        searchProps: {
            variant: "outlined",
            margin: "dense",
        },
        textLabels: {
            body: {
                noMatch: status,
            },
        },
        // customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
        //     <CustomUsersToolbar
        //         selectedRows={selectedRows}
        //         displayData={displayData}
        //         setSelectedRows={setSelectedRows}
        //         toggleUser={toggleUser}
        //         openEdit={showAgentEdit}
        //         toggling={agents.toggling}
        //     />
        // ),
    };

    const notify = (variant, msg, status) => {
        if (status == 401) {
            history.push("/", { expired: true });
        }
        enqueueSnackbar(msg, {
            variant: variant,
            action: (k) => (
                <IconButton
                    onClick={() => {
                        closeSnackbar(k);
                    }}
                    size="small"
                >
                    <Close fontSize="small" />
                </IconButton>
            ),
        });
    };


    const getBnrTrustAccReport = (token, id) => {
        const agentsInstance = axios.create(new AdminService().getHeaders(token));

        setAgents({ ...agents, loading: true });

        agentsInstance
            .get(new FinanceService().GET_BNR_TRUST_ACC_REPORT + '?per_page=10000')
            .then(function (response) {
                setAgents({ ...agents, loading: false });

                const d = response.data;

                if (d.data.length == 0) {
                    setStatus("There are no agents available.");
                } else {
                    var usrs = [];

                    d.data.forEach((u, i) => {
                        const newUser = u;
                        newUser["status2"] = u.user_status;
                        newUser["user_names"] = u.user_first_name + " " + u.user_last_name;

                        usrs.push(u);
                    });

                    setAgents({
                        ...agents,
                        data: usrs,
                    });
                }
            })
            .catch(function (error) {
                setAgents({ ...agents, loading: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }
                setStatus(e);

                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };

    ///////////////////////////////////

    ////////////////

    const clearagentInfo = () => {
        setBusinessDate({ value: "", error: "" });
        setBankLeBook({ value: "", error: "" });
        settrust_acct_open_bal_lcy({ value: 0, error: "" });
        settrust_acct_dep_bal_lcy({ value: 0, error: "" });
        settrust_acct_wd_bal_lcy({ value: 0, error: "" });
        settrust_acct_close_bal_lcy({ value: 0, error: "" });
        seteplat_acct_open_bal_lcy({ value: 0, error: "" });
        seteplat_acct_dep_bal_lcy({ value: 0, error: "" });
        seteplat_acct_wd_bal_lcy({ value: 0, error: "" });
        seteplat_acct_close_bal_lcy({ value: 0, error: "" });
        setreason_for_difference({ value: "", error: "" });
    };

    const recordReport = () => {
        const createInstance = axios.create(
            new AdminService().getHeaders(accountData.token)
        );
        setAgents({ ...agents, saving: true });
        const data = {
            business_date: business_date.value.toUpperCase(),
            bank_le_book: bank_le_book.value,
            trust_acct_open_bal_lcy: trust_acct_open_bal_lcy.value,
            trust_acct_dep_bal_lcy: trust_acct_dep_bal_lcy.value,
            trust_acct_wd_bal_lcy: trust_acct_wd_bal_lcy.value,
            trust_acct_close_bal_lcy: trust_acct_close_bal_lcy.value,
            eplat_acct_open_bal_lcy: eplat_acct_open_bal_lcy.value,
            eplat_acct_dep_bal_lcy: eplat_acct_dep_bal_lcy.value,
            eplat_acct_wd_bal_lcy: eplat_acct_wd_bal_lcy.value,
            eplat_acct_close_bal_lcy: eplat_acct_close_bal_lcy.value,
            reason_for_difference: reason_for_difference.value
        };

        // if (agentEditMode.status) {
        //     updateAgent(data);
        //     return;
        // }

        console.log("recording bnr report .....");

        createInstance
            .post(new FinanceService().RECORD_BNR_REPORT, data)
            .then(function (response) {
                setAgents({ ...agents, saving: false });
                var d = response.data;
                var usrs = agents.data;
                const newUser = d.data;
                usrs.unshift(newUser);
                setAgents({
                    ...agents,
                    data: usrs,
                });
                //getBnrTrustAccReport(accountData.token);
                clearagentInfo();
                notify("success", response.data.message);
                setAddNewOpen(false);
            })
            .catch(function (error) {
                setAgents({ ...agents, saving: false });
                var e = error.message;

                if (error.response) {
                    e = error.response.data.message;
                }

                notify(error?.response?.status == 404 ? "info" : "error", e, error?.response?.status);
            });
    };


    return (<MuiPickersUtilsProvider utils={DateFnsUtils}>
        <div className={classes.root}>
            {/* Dialogs starts here */}

            {/* ////////////////////////// */}
            <Dialog
                open={addNewOpen}
                maxWidth="sm"
                fullWidth
                onClose={() => setAddNewOpen(false)}
            >
                <DialogTitle id="new-op">
                   Record BNR Trust Acc Report
                </DialogTitle>
                <DialogContent>
                    
                <Box mt={2}>
                    <DatePicker
                        fullWidth
                        disableToolbar
                        variant="inline"
                        format="dd-MMM-yyyy"
                        margin="dense"
                        disablePast
                        autoOk
                        label="Business Date"
                        value={business_date.value}
                        inputVariant="outlined"
                        onChange={(v) => {
                            setBusinessDate({ value: Format(v, ["dd-MMM-yyyy"]) , error: ""})
                        }}
                        InputProps={{
                            disableUnderline: true,
                            style: { paddingRight: 1 },
                        }}
                    />
                </Box>
                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    value={bank_le_book.value}
                                    placeholder={"Bank le book"}
                                    label={"Bank le book"}
                                    fullWidth
                                    onChange={(e)=>{
                                        setBankLeBook({ value: e.target.value, error: "" })
                                    }}
                                    helperText={bank_le_book.error}
                                    error={bank_le_book.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>
                    <Box style={{ backgroundColor: "#edeff9" }}>
                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    type="number"
                                    value={trust_acct_open_bal_lcy.value}
                                    placeholder={"Trust Account Opening Balance in LCY"}
                                    label={"Trust Account Opening Balance in LCY"}
                                    fullWidth
                                    onChange={(e)=>{
                                        settrust_acct_open_bal_lcy({value: e.target.value, error:""});
                                    }}
                                    helperText={trust_acct_open_bal_lcy.error}
                                    error={trust_acct_open_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>
                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    value={trust_acct_dep_bal_lcy.value}
                                    placeholder={"Trust Account Deposit Balance in LCY"}
                                    label={"Trust Account Deposit Balance in LCY"}
                                    fullWidth
                                    onChange={(e)=>{
                                        settrust_acct_dep_bal_lcy({value: e.target.value, error: ""});
                                    }}
                                    helperText={trust_acct_dep_bal_lcy.error}
                                    error={trust_acct_dep_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                        <Box mt={2}>
                            <Translate>
                                {({ translate }) => (
                                    <TextField
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        value={trust_acct_wd_bal_lcy.value}
                                        placeholder={"Trust Account Withdrawal Balance in LCY"}
                                        label={"Trust Account Withdrawal Balance in LCY"}
                                        fullWidth
                                        onChange={(e)=>{
                                            settrust_acct_wd_bal_lcy({value: e.target.value, error: ""});
                                        }}
                                        helperText={trust_acct_wd_bal_lcy.error}
                                        error={trust_acct_wd_bal_lcy.error !== ""}
                                    />
                                )}
                            </Translate>
                        </Box>
    

                    
                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    value={trust_acct_close_bal_lcy.value}
                                    placeholder={"Trust Account Closing Balance in LCY"}
                                    label={"Trust Account Closing Balance in LCY"}
                                    fullWidth
                                    onChange={(e)=>{
                                        settrust_acct_close_bal_lcy({value: e.target.value, error: ""})
                                    }}
                                    helperText={trust_acct_close_bal_lcy.error}
                                    error={trust_acct_close_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>
                    </Box>


                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    value={eplat_acct_open_bal_lcy.value}
                                    placeholder={"E-Platform Opening Balance in LCY"}
                                    label={"E-Platform Opening Balance in LCY"}
                                    fullWidth
                                    onChange={(e)=>{
                                        seteplat_acct_open_bal_lcy({value: e.target.value, error: ""});
                                    }}
                                    helperText={eplat_acct_open_bal_lcy.error}
                                    error={eplat_acct_open_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    type="text"
                                    value={eplat_acct_dep_bal_lcy.value}
                                    placeholder={"E-Platform Deposit Balance in LCY"}
                                    label={"E-Platform Deposit Balance in LCY"}
                                    fullWidth
                                    onChange={(e)=>{
                                        seteplat_acct_dep_bal_lcy({value: e.target.value, error: ""});
                                    }}
                                    helperText={eplat_acct_dep_bal_lcy.error}
                                    error={eplat_acct_dep_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    type="text"
                                    value={eplat_acct_wd_bal_lcy.value}
                                    placeholder={"E-Platform Withdrawal Balance in LCY"}
                                    label={"E-Platform Withdrawal Balance in LCY"}
                                    fullWidth
                                    onChange={(e) => {
                                        seteplat_acct_wd_bal_lcy({ value: e.target.value, error: "" });
                                    }}
                                    helperText={eplat_acct_wd_bal_lcy.error}
                                    error={eplat_acct_wd_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    type="text"
                                    value={eplat_acct_close_bal_lcy.value}
                                    placeholder={"E-Platform Closing Balance in LCY"}
                                    label={"E-Platform Closing Balance in LCY"}
                                    fullWidth
                                    onChange={(e) => {
                                        seteplat_acct_close_bal_lcy({ value: e.target.value, error: "" });
                                    }}
                                    helperText={eplat_acct_close_bal_lcy.error}
                                    error={eplat_acct_close_bal_lcy.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                    <Box mt={2}>
                        <Typography><b>Defference: </b>{trust_acct_close_bal_lcy.value - eplat_acct_close_bal_lcy.value}</Typography>
                    </Box>


                    <Box mt={2}>
                        <Translate>
                            {({ translate }) => (
                                <TextField
                                    size="small"
                                    variant="outlined"
                                    color="primary"
                                    type="text"
                                    value={reason_for_difference.value}
                                    placeholder={"Reason in case of difference"}
                                    label={"Reason in case of difference"}
                                    fullWidth
                                    onChange={(e) => {
                                        setreason_for_difference({ value: e.target.value, error: "" });
                                    }}
                                    helperText={reason_for_difference.error}
                                    error={reason_for_difference.error !== ""}
                                />
                            )}
                        </Translate>
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            clearUserInfo();
                            setAddNewOpen(false);
                            setAgentEditMode({ ...agentEditMode, status: false });
                        }}
                        variant="outlined"
                        color="primary"
                    >
                        <Translate id="agents.forms.buttons.cancel" />
                    </Button>
                    <Button
                        disabled={agents.saving}
                        variant="contained"
                        color="primary"
                        onClick={onRegisterClick}
                        disableElevation
                    >
                        {agents.saving ? (
                            <CircularProgress size={23} />
                        ) : agentEditMode.status ? (
                            "Save"
                        ) : (
                            <Translate id="users.forms.buttons.register" />
                        )}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Dialogs ends here */}
            <Box display="flex">
                <Box mr={2}>
                    {" "}
                    <AccountBalanceWallet color="primary" fontSize="large" />
                </Box>
                <Box flexGrow={1} display="flex" alignItems="center">
                    <Typography variant="h5">
                        <b>BNR</b>
                    </Typography>
                    <Box ml={1} mr={1} mt={1}>
                        <ArrowForwardIos fontSize="small" />
                    </Box>
                    <Typography variant="h6">Trust Acc Report</Typography>
                </Box>
                    <Button
                        className={classes.btn}
                        color="primary"
                        variant="contained"
                        size="medium"
                        startIcon={<Add />}
                        disableElevation
                        onClick={() => {
                            setIdData({ ...idData, open: true })
                            setAddNewOpen(true)
                        }}
                    >
                        New Report
                    </Button>
            </Box>
            <Box mt={3} />
            {agents.loading && <LinearProgress />}
            <MUIDataTable
                title={"BNR Trust Acc Report"}
                data={agents.data}
                columns={columns}
                options={options}
            />
        </div>
        </MuiPickersUtilsProvider>
    );
}


export default withLocalize(BnrTrustAccReport);